module.exports = __webpack_public_path__ + "img/hongbao.fba1118e.png";